/* eslint-disable no-extra-boolean-cast */
/**
 * Component to handle event WM clicks
 *
 * The module is handling events send to Tealium
 *
 * @module app/components/MarketingEvent.js
 */

var sendTracking = function sendTracking() {
    window.WH.messageBus.subscribe('cp.crmPopovers.displayed', function(key, data) {
        if (!!window.AnalyticsTactical) { 
            // eslint-disable-next-line new-cap
            window.AnalyticsTactical.Helpers.sendData('link', {
                EventCategory: 'On-site Messages',
                EventAction: data.campaignId,
                EventLabel: 'Displayed',
                ElementType: 'Welcome Messages',
                NonInteractionEvent: '1',
                CustomerAccountNumber: window.AnalyticsTactical.Helpers.getAccountId(),
            });
            document.querySelector('#wm-campaign').addEventListener('click', (function(event) {
                event && event.target && event.target.innerText && window.AnalyticsTactical.Helpers.sendData('link', {
                    EventCategory: 'On-site Messages',
                    EventAction: data.campaignId,
                    EventLabel: event.target.innerText,
                    elementType: 'Welcome Messages',
                    NonInteractionEvent: '0',
                    CustomerAccountNumber: window.AnalyticsTactical.Helpers.getAccountId(),
                });
            }
            ));
        }
    });
};

var startMarketingHandler = function startMarketingHandler() {

    if (window.WH.sportsbook.lang === 'es-es' || window.WH.sportsbook.lang === 'it-it') {
        sendTracking();
    }
};

export default {
    init: function() {
        window.console.log(' event tracking init');
        startMarketingHandler();
    },
};
